import "./Logos.css";
import "../common.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Logos() {

  const logos = [
    "/webLogo/Binghatti.png",
    "/webLogo/Easi.png",
    "/webLogo/RAK-therm.png",
    "/webLogo/Ramada.png",
    "/webLogo/Railtel.png",
    "/webLogo/Setco.png",
    "/webLogo/Emirates-NBN.png",
    "/webLogo/Flyairjets.png",
    "/webLogo/Forbes.png",
    "/webLogo/Magic-Travels.png",
    "/webLogo/Object-1.png",
  ];

  const logosLoop = [...logos, ...logos];

  //   const settings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 800,
  //   slidesToShow: 6,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   pauseOnHover: false,
  //   responsive: [
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 5
  //       }
  //     },
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 4
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 3
  //       }
  //     },
  //     {
  //       breakpoint: 576,
  //       settings: {
  //         slidesToShow: 2
  //       }
  //     }
  //   ]
  // };

  return (
    <div id="logos" className="mainclass">
      <div className="logos-strip">

        <div className="logos-lbl">
          Trusted by Global Brands and Emerging Industry Leaders
        </div>

        {/* <Slider {...settings} className="logos-row">
          {logos.map((logo, index) => (
            <div key={index}>
              <div className="logo-item">
                <img src={logo} alt="Logo" />
              </div>
            </div>
          ))}
        </Slider> */}
        <div className="marquee-container">
          <div className="marquee">
            {logosLoop.map((logo, index) => (
              <div className="marquee-item" key={index}>
                <img src={logo} alt="Logo" />
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}